<template>
  <AnalyticsWidget
    title="Inventory Summary"
    subTitle="Based on total inventory holdings"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight"
    >
    <div class="p-2">
      <LoadingPanel :loading="loading" />
      <div v-if="!loading">
        <AnalyticsDashboardValueRow>
          <div class="col">
            <AnalyticsDashboardValue
              title="Total Stock On Hand Value"
              :value="stockValueSummary.totalStockValue">
              {{formatCurrency(stockValueSummary.totalStockValue)}}              
              <template v-slot:info>&nbsp;</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Total Glass Stock On Hand"
              :value="stockValueSummary.totalStockGlassUnits">
              {{formatDecimal(stockValueSummary.totalStockGlassUnits, 2, true)}}m&sup2;
              <template v-slot:info>&nbsp;</template>
            </AnalyticsDashboardValue>            
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Total Glass Sheets"
              :value="stockValueSummary.totalSheets"
              helpTip="Total sheets including loose sheets, offcuts and block sheets">
              {{formatInteger(stockValueSummary.totalSheets, false, true)}}
              <template v-slot:info>Total sheet count</template>
            </AnalyticsDashboardValue>            
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Total Offcuts"
              :value="stockValueSummary.totalOffcuts"
              viewMoreLink="/inventory/glassoffcuts">
              {{formatInteger(stockValueSummary.totalOffcuts, false, true)}}
              <template v-slot:info>Total available offcut panel count at {{formatInteger(stockValueSummary.totalOffcutUnits, false, true)}}m&sup2;</template>
            </AnalyticsDashboardValue>            
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Total Blocks"
              :value="stockValueSummary.totalBlocks"
              viewMoreLink="/inventory/glassblocks">
              {{formatInteger(stockValueSummary.totalBlocks, false, true)}}
              <template v-slot:info>Containing {{formatInteger(stockValueSummary.totalBlockSheets, false, true)}} sheets at {{formatInteger(stockValueSummary.totalBlockUnits, false, true)}}m&sup2;</template>
            </AnalyticsDashboardValue>            
          </div>
        </AnalyticsDashboardValueRow>

        <AnalyticsDashboardValueRow>
          <div class="col-3">
            <AnalyticsDashboardValue
              title="Glass / Blocks Stock On Hand Value"
              :value="stockValueSummary.totalSheetValue - stockValueSummary.totalOffcutValue">
              {{formatCurrency(stockValueSummary.totalSheetValue - stockValueSummary.totalOffcutValue)}}              
              <template v-slot:info>Based on {{formatInteger(stockValueSummary.totalSheets, false, true)}} sheets at {{formatInteger(stockValueSummary.totalStockGlassUnits, false, true)}}m&sup2;</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col-3">
            <AnalyticsDashboardValue
              title="Offcuts Stock On Hand Value"
              :value="stockValueSummary.totalOffcutValue">
              {{formatCurrency(stockValueSummary.totalOffcutValue)}}      
              <template v-slot:info>Based on {{formatInteger(stockValueSummary.totalOffcuts, false, true)}} offcuts at {{formatInteger(stockValueSummary.totalOffcutUnits, false, true)}}m&sup2;</template>
            </AnalyticsDashboardValue>
          </div>
        </AnalyticsDashboardValueRow>
      </div>
    </div>
  </AnalyticsWidget>
</template>


<script>
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'
import AnalyticsDashboardValueRow from '@/modules/intelligence/components/analyticsDashboardValueRow'

export default {
  name: 'InventorySummaryWidget',
  components: {
    AnalyticsWidget,
    AnalyticsDashboardValue,
    AnalyticsDashboardValueRow
  },
  props: {
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
  },
  data() {
    return {
      loading: true,
      stockValueSummary: {}
    }
  },
  watch: {
  },
  mounted() {
    this.loading = true
    this.requestData()

    
  },
  beforeDestroy() {
    
  },
  methods: {
    requestData() {
       this.$apiService.analyticsService.getStockValueOnHandSummary()
      .then(response => {
        this.stockValueSummary = response.data
      })
      .finally(() => {
        this.loading = false
      })
      
    },
    
  }
}
</script>